import {
  DashboardNavIcon,
  MyTrypsNavIcon,
  StatsAndScoresNavIcon,
  LevelUpNavIcon,
  CampaignInfoNavIcon,
  // SponsorZoneIcon,
  LeaderboardNavIcon,
} from "../components/common/Icons";
import { ReactComponent as AccelerationIcon } from "../components/common/Navbar/trypIcons/acceleration.svg";
import { ReactComponent as BrakingIcon } from "../components/common/Navbar/trypIcons/brake.svg";
import { ReactComponent as CorneringIcon } from "../components/common/Navbar/trypIcons/cornering.svg";
import { ReactComponent as EcoIcon } from "../components/common/Navbar/trypIcons/eco.svg";
import { ReactComponent as FocusIcon } from "../components/common/Navbar/trypIcons/focus.svg";
import { ReactComponent as HandlingIcon } from "../components/common/Navbar/trypIcons/handling.svg";
import { ReactComponent as PhoneIcon } from "../components/common/Navbar/trypIcons/phone.svg";
import { ReactComponent as SpeedIcon } from "../components/common/Navbar/trypIcons/speed.svg";
import { ReactComponent as SteadinessIcon } from "../components/common/Navbar/trypIcons/steadiness.svg";
import { ReactComponent as SwerveIcon } from "../components/common/Navbar/trypIcons/swerve.svg";
import { ReactComponent as Total } from "../components/common/Navbar/trypIcons/total.svg";
import { ReactComponent as Other } from "../components/common/Navbar/trypIcons/other.svg";
import { ReactComponent as Tips } from "../components/common/Navbar/trypIcons/tips.svg";
import { ReactComponent as Techniques } from "../components/common/Navbar/trypIcons/techniques.svg";
import { ReactComponent as FunFacts } from "../components/common/Navbar/trypIcons/funFacts.svg";

// NavBar
export const NAVBAR_OPTIONS = [
  {
    name: "dashboard",
    icon: <DashboardNavIcon />,
  },
  {
    name: "stats",
    icon: <StatsAndScoresNavIcon />,
  },
  {
    name: "tryps",
    icon: <MyTrypsNavIcon />,
  },
  // {
  //   name: "sponsorZone",
  //   icon: <SponsorZoneIcon />,
  // },
  {
    name: "levelUp",
    icon: <LevelUpNavIcon />,
  },
  {
    name: "safeRoads",
    icon: <LeaderboardNavIcon />,
  },
  {
    name: "competitionInfo",
    icon: <CampaignInfoNavIcon />,
  },
];

// Tryps SVGS
export const TRYP_SVGS = {
  acceleration: <AccelerationIcon />,
  brake: <BrakingIcon />,
  cornering: <CorneringIcon />,
  eco: <EcoIcon />,
  focus: <FocusIcon />,
  handling: <HandlingIcon />,
  phone: <PhoneIcon />,
  speed: <SpeedIcon />,
  steadiness: <SteadinessIcon />,
  swerve: <SwerveIcon />,
  total: <Total />,
  other: <Other />,
  tips: <Tips />,
  techniques: <Techniques />,
  funFacts: <FunFacts />,
};

// Paths
export const SIGNIN_PATH = "/";
export const TOKEN_SIGNIN_PATH = "/integrations";
export const RESET_PATH = "/reset";
export const HOME_PATH = "/home";
export const NOT_FOUND_PATH = "/notfound";

// Option State
export const OPTION_ADMIN_PORTAL = "adminPortal";
export const OPTION_LIST_COMPANIES = null;
export const OPTION_ADD_COMPANY = "addCompany";
export const OPTION_VIEW_COMPANY = "viewCompany";
export const OPTION_ADD_TEAMS = "addTeams";
export const OPTION_EDIT_TEAM = "editTeam";
export const OPTION_CREATE_COMP_PARENT = "createCompParent";
export const OPTION_CREATE_COMPETITION = "createCompetition";
export const OPTION_EDIT_COMPETITION = "editCompetition";
export const OPTION_CAMPAIGN_BUILDER = "campaignBuilder";

// Tryps
export const SKILLS_LIST = [
  "total",
  "handling",
  "focus",
  "eco",
  "acceleration",
  "cornering",
  "swerve",
  "steadiness",
  "speed",
  "brake",
  "phone",
];
export const STAT_NAMES = {
  eco: "eco",
  acceleration: "acceleration",
  deceleration: "braking",
  speeding: "speed",
  cool: "handling",
  cornering: "cornering",
  jerk: "steadiness",
  alert: "focus",
  phoneHandling: "phone",
  swerve: "swerve",
};
export const STAT_CATEGORIES = {
  eco: ["acceleration", "braking", "speed"],
  handling: ["cornering", "steadiness"],
  focus: ["phone", "swerve"],
};
export const VID_CATEGORIES = [
  "acceleration",
  "braking",
  "speed",
  "cornering",
  "steadiness",
  "phone",
  "swerve",
  "fun facts",
  "techniques",
  "tips",
];
export const EVENT_COLORS = {
  Severe: "#d30013",
  Moderate: "#ed6a1d",
  Mild: "#fec32c",
};
export const SCORE_COLORS = {
  "100 - 80": "#4b9d1a",
  "79 - 70": "#60c624",
  "69 - 60": "#fee132",
  "59 - 50": "#f7563c",
  "49 - 40": "#d42c26",
  "39 or less": "#af1210",
};

// Stripe
export const STRIPE_FLAT = 0.3;
export const STRIPE_PERCENT = 0.029;

// Min/max lengths
export const PASSWORD_MIN_LENGTH = 8;

// Misc
export const ACTIONS_BTN = "...";

// TEMP SAFE ROADS
//Safe Roads
export const SR_LEADERBOARDS = "Leaderboards";
export const SR_TIER = "Tier";
export const SR_DIVISION = "Divisions:";
export const SR_MOBILE_LABEL = "Divisions";
export const SR_COMP_DDL_LABEL = "Competitions";
export const SR_ALL = "All Teams";
export const SRT_LEAGUES = ["OHL", "WHL", "QJMHL"];
export const SRT_DIVISIONS = ["West", "East", "North", "South"];

export const SRT_TEAMS = [
  [
    "Erie Otters",
    "Portland Winterhawks",
    "Edmonton Oil Kings",
    "Shawinigan Cataractes",
    "London Knights",
    "Laval Titan",
    "Moncton Wildcats",
    "Quebec Ramparts",
    "Calgary Hitmen",
    "Niagara IceDogs",
    "Flint Firebirds",
    "Kelowna Rockets",
    "Halifax Mooseheads",
  ],
  [
    "Erie Otters",
    "Windsor Spitfires",
    "Niagara IceDogs",
    "London Knights",
    "Barrie Colts",
    "Flint Firebirds",
    "Mississauga Steelheads",
  ],
  [
    "Edmonton Oil Kings",
    "Portland Winterhawks",
    "Calgary Hitmen",
    "Kelowna Rockets",
    "Winnipeg Ice",
    "Brandon Weat Kings",
    "Victoria Royals",
  ],
  [
    "Saint John Sea Dogs",
    "Halifax Mooseheads",
    "Quebec Ramparts",
    "Shawinigan Cataractes",
    "Cornwall Royals",
    "Laval Titan",
    "Moncton Wildcats",
  ],
];
export const SRT_NUM = "99.87";
export const PREMIUM_PAGES = ["tryps", "levelUp"];

export const ENV_URLS = {
  "trypscore-dev": "https://trypscore-admin-develop.web.app",
  trypscore: "https://trypscore-admin-staging.web.app",
  "trypscore-prod": "https://trypscore-admin.web.app",
  "trypscore-prod-uk": "https://trypscore-admin-uk.web.app",
};

export const stats = [
  { id: "acceleration", name: "Acceleration" },
  { id: "deceleration", name: "Brake" },
  { id: "cornering", name: "Cornering" },
  { id: "eco", name: "Eco" },
  { id: "alert", name: "Focus" },
  { id: "cool", name: "Handling" },
  { id: "phoneHandling", name: "Phone" },
  { id: "speeding", name: "Speed" },
  { id: "jerk", name: "Steadiness" },
  { id: "swerve", name: "Swerve" },
  { id: "total", name: "Total" },
];

export const DEV_PROJECT_IDS = ["trypscore-dev", "trypscore"];

export const PROJECTS = [
  {
    name: "Develop",
    id: "trypscore-dev",
    url: "https://trypscore-learning-center.web.app/",
    icons: ["😈"],
  },
  {
    name: "Staging",
    id: "trypscore",
    url: "https://tryps-plus-staging.web.app/home",
    icons: [],
  },
  {
    name: "North America",
    id: "trypscore-prod",
    url: "https://dashboard.saferoadschallenge.com/",
    icons: ["🇺🇸", "🇨🇦"],
  },
  {
    name: "United Kingdom",
    id: "trypscore-prod-uk",
    url: "https://dashboard.saferoadschallenge.uk/",
    icons: ["🇬🇧"],
  },
];

export const ConstantNames = {
  MAIN_BANNERS: "srcDashboardMainBanners",
  FEATURED_BANNERS: "srcFeaturedChallengeBanners",
};

export const reservedRequests = [
  "competitionCampaigns-getSRCChallengeInfo",
  "competitionGroups-getLeaderboardForCompetition",
];
